import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import BaseEffect from '../../../domain/entities/BaseEffect';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexBaseEffectsSuccess: {
      const result = action.payload as PaginatedResult<BaseEffect>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
